import { render, staticRenderFns } from "./vistaReferenciasDeudor.vue?vue&type=template&id=88bd8a7a&scoped=true"
import script from "./vistaReferenciasDeudor.vue?vue&type=script&lang=js"
export * from "./vistaReferenciasDeudor.vue?vue&type=script&lang=js"
import style0 from "./vistaReferenciasDeudor.vue?vue&type=style&index=0&id=88bd8a7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88bd8a7a",
  null
  
)

export default component.exports